module.exports = __webpack_public_path__ + "img/03.8f9f509f.png";